import { Inbox } from '@novu/react';

import { useAuth } from '../providers/AuthProvider';

const NOVU_APP_ID = import.meta.env.VITE_NOVU_APP_ID || '';

export function NotificationDropdown() {
  const { user } = useAuth();

  if (!user || !NOVU_APP_ID) {
    return null;
  }

  return (
    <Inbox
      applicationIdentifier={NOVU_APP_ID}
      subscriberId={user.id}
      appearance={{
        baseTheme: {
          // Aurora DS (dark) — Cosmos raised surface, brand blue, IDS radius.
          // Novu wymaga stałych wartości, więc hexy = tokens.css (--ids-*).
          variables: {
            colorBackground: '#1A2336', // --ids-surface-raised (cosmos-750)
            colorForeground: '#F8FAFC', // --ids-text
            colorPrimary: '#3B82F6', // --ids-brand (blue-500)
            colorSecondaryForeground: '#94A3B8', // --ids-text-muted (cosmos-300)
            borderRadius: '10px', // --ids-radius-md
          },
        },
        // Trigger dzwonka stylizowany jak .iconbtn topbara + kropka
        // nieprzeczytanych jak .dot-indicator (components.css) — żeby dzwonek
        // nie odstawał od pozostałych ikon. Jak wyżej: stałe wartości = tokeny.
        elements: {
          inbox__popoverTrigger: {
            width: '42px', // .iconbtn (42×42)
            height: '42px',
            borderRadius: '10px', // --ids-radius-md
            color: '#94A3B8', // --ids-text-muted (cosmos-300)
          },
          bellDot: {
            width: '7px', // .dot-indicator
            height: '7px',
            background: '#EF4444', // --ids-danger
          },
        },
      }}
    />
  );
}
